module.exports = __webpack_public_path__ + "static/media/navLogoFile.b1e41e4d.png";